import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {OpenLauncherAction} from "../menu-actions/open-launcher-menu-action";
import {OpenNewBugAction} from "../menu-actions/new-bug-menu-action";
import {HideThisMenuAction} from "../menu-actions/hide-this-menu-action";
import {CipNavigationMenuAction} from "../menu-actions/cip-navigation-menu-action";
import {ResetConfigurationsAction} from "../menu-actions/reset-configuration-menu-action";
import {ClearLocalStorageMenuAction} from "../menu-actions/clear-local-storage-menu-action";

export function generateMenuItems(services: IInsideOrbitMenuServices){
    return [
        new OpenLauncherAction(services),
        new OpenNewBugAction(services),
        new HideThisMenuAction(services),
        new CipNavigationMenuAction(services),
        new ClearLocalStorageMenuAction(services),
        new ResetConfigurationsAction(services)
    ];
}